var map = {
	"./Ballon Path.jpeg": 2456,
	"./India Book of Record Certificate.jpeg": 7968,
	"./India and Limca Book of Records Medals.jpeg": 6025,
	"./Limca Book of record Certificate.jpeg": 6079,
	"./Participation Certificate.jpeg": 7733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3272;